import { SignalRService } from './../../services/signalR.service';
import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-send-qr-code',
  templateUrl: './send-qr-code.component.html',
  styles: []
})
export class SendQrCodeComponent implements OnInit, OnDestroy {
  hubConnection: any;

  constructor(
    private signalRService : SignalRService,) { 
      this.signalRService.checkSendQrCode.subscribe(x => {
        this.hubConnect(x);
    })
  }
  data: string;
  shipmentNumber: string ;
  listGoodCode: string;
  amount: string;
  senderName: string;
  receiverName: string;

  width: number;
  widthEle: number;
  async ngOnInit() {
    this.width = screen.width;
    this.widthEle = (this.width / 2) - 150;
    
    document.body.style.backgroundColor = '#fff';

    await this.signalRService.Connect();
    await this.signalRService.registerUserToHub();
    await this.signalRService.awaitSendQrCode();
  }

  ngOnDestroy() {
    document.body.style.removeProperty('background-color');
    this.signalRService.Disconnect();
  }
  async hubConnect(res: any) {
    if(res){
      this.data = res.qrCode;
      this.shipmentNumber = res.shipmentNumber;
      this.listGoodCode = res.listGoodCode;
      this.amount = res.amount;
      this.senderName = res.senderName;
      this.receiverName = res.receiverName;
    }
  }
}
